module.exports = __webpack_public_path__ + "img/DOWNLOAD.64a3d354.svg";